import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: "http://localhost:9000",
    }),
    tagTypes: ["Books", "Book"],
    endpoints: (builder) => ({
        getBooks: builder.query({
            query: () => "/books",
            providesTags: ["Books"],
        }),
        getBook: builder.query({
            query: (id) => `/books/${id}`,
            providesTags: (result, error, id) => [{ type: "Book", id }],
        }),
        addBook: builder.mutation({
            query: (data) => ({
                url: "/books",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Books"],
        }),
        editBook: builder.mutation({
            query: (data) => ({
                url: `/books/${data.id}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: (result, error, data) => [
                "Books",
                { type: "Book", id: data.id },
            ],
        }),
        deleteBook: builder.mutation({
            query: (id) => ({
                url: `/books/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Books"],
        }),
    }),
});

export const {
    useGetBooksQuery,
    useAddBookMutation,
    useGetBookQuery,
    useDeleteBookMutation,
    useEditBookMutation,
} = apiSlice;
